export var OHSVariables = {
   breakpoint: 768
}